export default function NotFound() {
  return (
    <section data-testid="page-notfound">
      <h1 className="text-2xl font-bold">Page not found</h1>
      <p className="mt-2 text-stone-600">Coming soon.</p>
    </section>
  );
}
